import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader, AppBar, Tabs, Tab } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import breakpoints from "../../assest/theme/base/breakpoints";
import MaterialBox from "../../components/MaterialBox";
import { DesignationContext } from "../../context/designationcontext";

const RegularizationRequest = () => {
  const { handleClearSelection } = useContext(DesignationContext);

  const tablist = JSON.parse(sessionStorage.getItem("RegApp"));
  const navigate = useNavigate();
  const {
    user,
    AccessData,

    setHRreqularzation,

    setMangerApproval,
  } = useContext(UserDetailsContext);
  const id = user?.id;
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  let MainValue;

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "HrApproval" && item.can_access
    )
  ) {
    if (tablist === "HR") {
      MainValue = "HR";
    } else if (tablist === "HRList") {
      MainValue = "HRList";
    } else {
      MainValue = "Employee";
    }
  }
  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "ManagerApproval" && item.can_access
    )
  ) {
    if (tablist === "ManagerList") {
      MainValue = "ManagerList";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    !AccessData.some(
      (item) =>
        item.component === "ManagerApproval" || item.component === "HrApproval"
    )
  ) {
    MainValue = "Employee";
  }

  const [regularizationList, setRegularizationList] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
  const [tabValue, setTabValue] = useState(MainValue); //Used to store current selected tab

  console.log("tabValue:", tabValue);

  const regularizationListTable = {
    columns: [
      {
        field: "firstName",
        headerName: "User Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "checkIn",
        headerName: "Check In",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "checkOut",
        headerName: "Check Out",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
      {
        field: "reason",
        headerName: "Reason",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },

      {
        field: "Allstatus",
        headerName: "Status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: regularizationList.map((regularization) => ({
      id: regularization.id,
      firstName:
        regularization.user.firstName + " " + regularization.user.lastName,
      checkIn: regularization.checkIn,
      checkOut: regularization.checkOut,
      reason: regularization.reason,
      teamApproval: regularization.teamApproval
        ? regularization.teamApproval?.charAt(0).toUpperCase() +
          regularization.teamApproval?.slice(1)
        : "",
      hrApproval: regularization.hrApproval
        ? regularization.hrApproval?.charAt(0).toUpperCase() +
          regularization.hrApproval?.slice(1)
        : "",
      Allstatus:
        regularization.status == "pending"
          ? regularization.approvalStatus !== null
            ? `Pending By ${regularization.approvalStatus?.approver?.firstName} ${regularization.approvalStatus?.approver?.lastName}`
            : regularization?.hrApproval == "pending"
            ? "Pending By Hr"
            : "Approved By Hr"
          : regularization.status == "rejected"
          ? "Rejected"
          : regularization.status == "approved"
          ? "Approved"
          : "",
      status:
        regularization.status?.charAt(0).toUpperCase() +
        regularization.status?.slice(1),
    })),
  };

  useEffect(() => {
    getteamleadeID();
    const tabName = JSON.parse(sessionStorage.getItem("RegApp"));

if(tabName){
  setTabValue(tabName);
}else{
  setTabValue("Employee");
}

  }, []);

  const [TeamLeaderID, setTeamLeaderID] = useState([]);

  const getteamleadeID = async () => {
    const query = `  
   query{
  allManagers{
    id
    status
    lastupdate
    user{
      id
      empid
      department
      firstName
      lastName
      
    }
  }
}
`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const managerList = response.data.data.allManagers;
      const filterdata = managerList.filter(
        (val) => val.user.empid == user.empid
      );
      let dataid = filterdata[0]?.user?.id;
      localStorage.setItem("reqteam", dataid);
      setTeamLeaderID(filterdata);
      console.log("filterdatafilterdata:", filterdata);

      // setManagerList(managerList);
      // setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", managerList);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const handleNewRegularization = () => {
    navigate("/regularization-request/add-regularization");
  };
  const onRegularizationListClick = (e) => {
    console.log("onRegularizationListClick:", e?.id, e);
    if (e?.id) {
      if (tabValue == "HR") {
        navigate(`/regularization-request/RegularzationApproval?id=${e?.id}`);
        return;
      } else if (tabValue == "HRList") {
        navigate(`/regularization-request/RegularzationApproval?id=${e?.id}`);
        return;
      } else if (tabValue == "Manager") {
        navigate(`/regularization-request/RegularzationApproval?id=${e?.id}`);
        return;
      } else if (tabValue == "ManagerList") {
        navigate(`/regularization-request/RegularzationApproval?id=${e?.id}`);
        return;
      } else {
        navigate(`/regularization-request/regularization-details?id=${e?.id}`);
      }
      if (
        e.row.hrApproval == "Approved" &&
        e.row.teamApproval == "Approved" &&
        e.row.status == "Approved"
      ) {
        navigate(`/regularization-request/ViewRegularzation?id=${e?.id}`);
        return;
      }
      if (
        e.row.hrApproval == "Pending" &&
        e.row.teamApproval == "Approved" &&
        e.row.status == "Pending"
      ) {
        console.log("Correct");

        navigate(`/regularization-request/ViewRegularzation?id=${e?.id}`);
        return;
      }
      if (
        e.row.hrApproval == "Rejected" &&
        e.row.teamApproval == "Rejected" &&
        e.row.status == "Rejected"
      ) {
        console.log("Correct");

        navigate(`/regularization-request/ViewRegularzation?id=${e?.id}`);
        return;
      }
    }
  };

  const handleSetTabValue = (event, newValue) => {
    if (newValue == "HR") {
      setHRreqularzation(true);
      sessionStorage.setItem("RegApp", JSON.stringify(newValue));
    } else if (newValue == "Manager") {
      setMangerApproval(true);
    } else if (newValue == "HRList") {
      sessionStorage.setItem("RegApp", JSON.stringify(newValue));
    } else if (newValue == "ManagerList") {
      sessionStorage.setItem("RegApp", JSON.stringify(newValue));
    } else if (newValue == "Employee") {
      sessionStorage.setItem("RegApp", JSON.stringify(newValue));
    }
    setTabValue(newValue);
  };
  console.log("newValue:", tabValue);

  const datahandelar = async () => {
    if (tabValue == "HR") {
      const query = `
   query regularaizationRequestAllList{ 

  requestRegularizationAll{ 

    data { 

      id 

      checkIn 

      checkOut 

      reason 

      status 

      teamleaderId 

      teamApproval 

      hrApproval 
       user{ 

        id 

        firstName 

        lastName 

        email 

      } 


      approvalStatus { 

        id 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

        status 

      } 

      status 

    } 

    success 

    error 

    message 

  } 

} 

`;

      const encodedId = btoa(user?.id);
      console.log("Error1");

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            // variables: {
            //   id: TeamLeaderID[0]?.user.id,
            // },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("regularizationListHRR", response);
        // Extract department data from the response
        const regularizationList =
          response.data.data.requestRegularizationAll?.data;

        setRegularizationList(regularizationList || []);
        setPageState({ ...pageState, loading: false, state: "success" });

        console.log("Response:", regularizationList);
      } catch (error) {
        console.error("ResponseError1:", error.response.data);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "Manager") {
    
      const query = `
     query GetRegularizationByTeamLeader($id: String!) {
  requestRegularizationTeamAll(id: $id) {
   data {
      id
      checkIn
      checkOut
      reason
      status
      teamleaderId
      teamApproval
      hrApproval
      user{
        id
        firstName
        lastName
        email
      }
      approvalStatus {
        id
        approver{
          id
          firstName
          lastName
          email
        }
        status
      }
    }
    success
    error
    message
  }
}
            `;

      const encodedId = btoa(user?.id);

      console.log("Error2");

      let reportnum = localStorage.getItem("reqteam");
      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              //   id: "VXNlck5vZGU6" + "" + encodedId,
              id: user?.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("regularizationListMAnager", response);
        // Extract department data from the response
        const regularizationList =
          response.data.data.requestRegularizationTeamAll?.data;

        setRegularizationList(regularizationList || []);
        setPageState({ ...pageState, loading: false, state: "success" });

        console.log("Response:", regularizationList);
      } catch (error) {
        console.error("ResponseError2:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "ManagerList") {
      const query = `
     query regularizationRequestAllListByTeamLeader($id: String!){ 

  requestRegularizationTeamAll(id: $id){ 

    data { 

      id 

      checkIn 

      checkOut 

      reason 

      status 

      teamleaderId 

      teamApproval 

      hrApproval 

      user{ 

        id 

        firstName 

        lastName 

        email 

      } 

      approvalStatus { 

        id 

        approver{ 

          id 

          firstName 

          lastName 

          email 

        } 

        status 

      } 

    } 

    success 

    error 

    message 

  } 

} 
 
            `;

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              id: user?.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("regularizationListMAnager", response);
        // Extract department data from the response
        const regularizationList =
          response.data.data.requestRegularizationTeamAll?.data;

        setRegularizationList(regularizationList || []);
        setPageState({ ...pageState, loading: false, state: "success" });

        console.log("Response:", regularizationList);
      } catch (error) {
        console.error("ResponseError3:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else if (tabValue == "HRList") {
      const query = `
           query GetRegularizationByTeamLeader($id: String!) {
  requestRegularizationTeamAll(id: $id) {
   data {
      id
      checkIn
      checkOut
      reason
      status
      teamleaderId
      teamApproval
      hrApproval
      user{
        id
        firstName
        lastName
        email
      }
      approvalStatus {
        id
        approver{
          id
          firstName
          lastName
          email
        }
        status
      }
    }
    success
    error
    message
  }
}
  `;

      const encodedId = btoa(user?.id);
      let reportnum = localStorage.getItem("reqteam");

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              id: user?.id,
            },

            // variables: {
            // //   id: "VXNlck5vZGU6" + "" + encodedId,
            //   id: TeamLeaderID[0]?.user.id,
            // },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("regular", response);
        // Extract department data from the response
        const regularizationList =
          response.data.data.requestRegularizationTeamAll?.data;

        setRegularizationList(regularizationList || []);
        setPageState({ ...pageState, loading: false, state: "success" });

        console.log("Response:", regularizationList);
      } catch (error) {
        console.error("ResponseError4:", error.message);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    } else {
      const query = `query regularizationRequestByMe($id: String!) { 

  regularizationRequestByMe(id: $id) { 

    data { 

      id 

      user{
       id
       firstName
       lastName
      }

      checkIn 

      checkOut 

      reason 

      status 

      teamleaderId  

      teamApproval 

      hrApproval 

      approvalStatus { 

        id 

        status

        approver { 

          id 

          firstName 

          lastName 

          email 

        } 

      } 

      status 

    } 

    success 

    error 

    message 

  } 

} `;

      const encodedId = btoa(user?.id);
      console.log("Error5");

      try {
        setPageState({ ...pageState, loading: true });

        const response = await axios.post(
          BASEURL,
          {
            query: query,
            variables: {
              id: user?.id,
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("regularizationList", response);

        const regularizationList =
          response.data.data.regularizationRequestByMe.data;

        setRegularizationList(regularizationList || []);
        setPageState({ ...pageState, loading: false, state: "success" });

        console.log("Response:", regularizationList);
      } catch (error) {
        console.error("ResponseError5:", error.response.data);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    }
  };
  useEffect(() => {
    handleClearSelection();
    datahandelar();
  }, [tabValue]);
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Regularization List
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of regularization that you can get details of regularization.
                            </MaterialTypography> */}
              </Stack>
              <MaterialBox alignItems="center" width="60%">
                <MaterialBox width="80%">
                  <AppBar position="static">
                    <Tabs
                      orientation={tabsOrientation}
                      value={tabValue}
                      onChange={handleSetTabValue}
                      sx={{ backgroundColor: "transparent" }}
                    >
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.module === "RegularaizationRequest" &&
                            item.component === "HrApproval" &&
                            item.can_access
                        ) && <Tab label="HR List" value="HR" />}
                      {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            (item.module === "RegularaizationRequest" &&
                            item.component === "HrApproval" &&
                            item.can_access) || ( item.module === "RegularaizationRequest" &&
                            item.component === "ManagerApproval" &&
                            item.can_access)
                        ) && <Tab label="Team List" value="HRList" />}

                      {/* {AccessData &&
                        Array.isArray(AccessData) &&
                        AccessData.some(
                          (item) =>
                            item.module === "RegularaizationRequest" &&
                            item.component === "ManagerApproval" &&
                            item.can_access
                        ) && <Tab label="Manager List" value="ManagerList" />} */}

                      <Tab label="My List" value="Employee" />
                    </Tabs>
                  </AppBar>
                </MaterialBox>
              </MaterialBox>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddRegularaization" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewRegularization()}
                  >
                    Regularize
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={regularizationListTable.rows}
          customHeight={500}
          columns={regularizationListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRegularizationListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No regularization found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any regularization details. Click on
                  the "Add regularization" button to start adding regularization
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default RegularizationRequest;
